import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import "./assets/style/style.scss";
import "./plugins/toast";
import { separator, mask, separatorFilter } from "./plugins/mask-separator";
Vue.directive("separator", separator);
Vue.directive("mask", mask);
Vue.filter("separator", separatorFilter);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
